<template>
    <div id="top-bar">
        <div id="tb-main">
            <div class="tb-title-area" @click="toIndex">汕头龙湖产业开发区技术创新公共服务平台</div>
            <div class="nav-area">
                <ul>
                    <li :class="{'cur': infoType == 1 ? true : false }" @click="toInfo(1)">政策文件</li>
                    <li :class="{'cur': infoType == 6 ? true : false }" @click="toInfo(6)">招商引资</li>
                    <li :class="{'cur': infoType == 7 ? true : false }" @click="toInfo(7)">"工改工"专栏</li>
                    <li :class="{'cur': infoType == 3 ? true : false }" @click="toInfo(3)">工作动态</li>
                    <!-- <li :class="{'cur': infoType == 4 ? true : false }" @click="toInfo(4)">政务公告</li> -->
                    <li :class="{'cur': infoType == 5 ? true : false }" @click="toInfo(5)">企业信息</li>
                </ul>
            </div>
            <div class="bfa-wrapper" style="display: flex; align-items: center;">
                 <a class="btn-front-admin" href="#" @click="toLogin">进入管理前台</a>
                 <a style="margin-left: 10px;" class="btn-front-admin" href="#" @click="to12345">12345热线</a>
            </div>           
        </div>
        <!-- <div id="logout" @click="doLogout" v-if="isLogin">退出</div> -->
    </div>
</template>
<script>
export default {
    name: 'Header',
    props: {
        infoType: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {}
    },
    methods: {
        toInfo(type) {
            this.$router.push(`/info?type=${type}`)
        },
        doLogout() {
            localStorage.removeItem('token')
            this.$router.push('/login')
        },
        toIndex() {
            this.$router.push('/')
        },
        toLogin() {
            this.$router.push('/login')
        },
        to12345() {
            window.open('https://12345.shantou.gov.cn/pact.html')
        }
    },
    computed: {
        isLogin() {
            return localStorage.getItem('token')
        }
    },
}
</script>

<style>
#top-bar {
    width: 100%;
    border-bottom: 1px solid #b7bac3;
    padding: 14px 0;
    display: flex;
    justify-content: center;
}

#tb-main {
    width: 1200px; display: flex;
}

.tb-title-area {
    background: url('~@/assets/logo.png') no-repeat;
    background-size: 60px;
    height: 60px;
    text-indent: 70px;
    line-height: 60px;
    font-size: 20px;
    color: #0648a8;
    /* color: #a40000; */
    font-weight: bold;
    cursor: pointer;
}

.nav-area {
    padding-top: 20px;
    margin-left: 40px;
}
.nav-area ul {    
    display: flex;
}
.nav-area li {
    border-right: 1px solid #7e8c97;
    padding: 0 14px;
    font-size: 14px;
    color: #7e8c97;
    /* color: #bcaaaa; */
    cursor: pointer;
}
.nav-area li:last-child {
    border: none;
}
.nav-area li.cur {
    font-size: 14px;
    color: #235ca3;
    /* color: #e60012; */
    font-weight: bold;
}
.bfa-wrapper {
    margin-left: 40px;
    /*padding-top: 14px;*/
}
.btn-front-admin {
    display: block;
    background-color: #01479d;
    /* background-color: #a40000; */
    color: #fff;
    text-align: center;
    font-size: 14px;
    border-radius: 16px;
    height: 32px;
    line-height: 32px;
    padding: 0 10px;
}

#logout {
    line-height: 60px;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue